/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getFieldEngagmentList = (params) =>
  makeApiCall(`/cnc/field-engagement/list`, 'POST', params);

export const getFieldEngagmentMoe = (params) =>
  makeApiCall(`/cnc/field-engagement/moe`, 'POST', params);

export const getFieldEngagmentDetails = (params) =>
  makeApiCall(`/cnc/field-engagement/details`, 'POST', params);
